import { Popover } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CloseOutlined } from '@ant-design/icons';

import './basic-installation-pop-over.scss';

const Content = ({ closePopOver }: { closePopOver: () => void }): JSX.Element => {
    const { t } = useTranslation();

    return (
        <div data-testid="basic-installation-content" className="content">
            <div className="content__description"> {t('PRICING_AREA.BASIC_INSTALLATION_CONTENT')}</div>
            <CloseOutlined className="content__close-icon" onClick={closePopOver} />
        </div>
    );
};

const BasicInstallationPopOver = (): JSX.Element => {
    const { t } = useTranslation();
    const [showPopOver, setShowPopOver] = useState(false);

    const handleVisibleChange = () => setShowPopOver(!showPopOver);

    return (
        <Popover
            placement="bottomRight"
            content={<Content closePopOver={() => setShowPopOver(false)} />}
            trigger="click"
            open={showPopOver}
            onOpenChange={handleVisibleChange}
        >
            <div data-testid="basic-installation-pop-over" className="basic-installation" onClick={handleVisibleChange}>
                {t('PRICING_AREA.BASIC_INSTALLATION')}
            </div>
        </Popover>
    );
};

export default BasicInstallationPopOver;
